<template>
  <div class="layout-inner">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">

        <div class="row data_privacy">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="row">
              <div class="col-12 header">
                <img class="logo" src="../../../assets/theme/default/img/pragyaLogo.svg" alt="Pragya Systems Logo">
              </div>
            </div>
            <div class="row">
              <div class="col-12">

                <div class="pg_sec">
                  <div class="pg_sec_head">
                    Xprize Data
                  </div>
                  <div class="pg_sec_content">
                    Your participation in Pragya platform is in conjunction with the
                    XPRIZE Rapid Reskilling Competition. Evaluation of our team’s performance
                    in the competition relies on the collection and sharing of your anonymized
                    data. If you agree to the terms of use of this site, the following data will
                    be tracked and shared with XPRIZE: training start date and training end date.
                  </div>
                  <div class="pg_sec_action">
                    <input type="checkbox" id="tnc_chkbox" v-model="dataOptOut">
                    I would like to opt-out of sharing my training data with XPrize
                  </div>
                </div>


                <div class="pg_sec" style="padding-bottom: 15px;">
                  <div class="pg_sec_head">
                    Support On Your Phone
                  </div>
                  <div class="pg_sec_content">
                    We’ll text you motivation and reminders to support you during this program.
                    Msg & data rates may apply, text STOP to end. If you don’t wish to receive these texts,
                    please select Opt-out below.
                  </div>
                  <div class="pg_sec_action">
                    <input type="checkbox" id="tnc_chkbox2" v-model="mobileDataOptOut">
                    I would like to opt-out of receiving support on my mobile phone
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <button class="btn" @click="dataOptOutSave">Continue</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { getItem } from '../../../storage'
  import Navbar from '../../misc/components/./Navbar'

  export default {
    name: 'dataPrivacy',
    props: ['userObj'],
    components: {
      Navbar
    },
    data: () => {
      return {
        dataOptOut: false,
        mobileDataOptOut: false
      }
    },
    mounted () {
      if (!this.userObj) {
        getItem('userobj').then(data => {
          console.log('data: ', data)
          this.dataOptOut = data.dataOptOut
          this.mobileDataOptOut = data.mobileDataOptOut
        })
      } else {
        this.dataOptOut = this.userObj.dataOptOut
        this.mobileDataOptOut = this.userObj.mobileDataOptOut
      }
    },
    methods: {
      ...mapActions([
        'loadSaveDataOptOut'
      ]),
      async dataOptOutSave () {
        var formData = new FormData()
        formData.append('dataOptOut', this.dataOptOut)
        formData.append('mobileDataOptOut', this.mobileDataOptOut)
        this.loadSaveDataOptOut(formData).then(res => {
          if (res.status !== 400) {
            return this.$router.push({ name: 'dashboard' })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/login/components/DataPrivacy.vue